var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"ta"},[(_vm.plaintext)?_c('pre',{staticClass:"col-form-label d-block"},[_vm._v(_vm._s(_vm.value))]):_c('b-form-textarea',_vm._g(_vm._b({attrs:{"placeholder":_vm.gPlaceholder,"aria-label":_vm.ariaLabel}},'b-form-textarea',_vm.props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }